<template>
  <div class="relative">
    <slot></slot>
    <label
      v-if="label"
      class="block mb-2 text-sm group-disabled:opactity-50"
      :for="name"
      >{{ label }}</label
    >
    <div v-if="type === 'number'">
      <Field
        class="w-full px-2 py-1 text-lg border border-gray-200"
        :type="type"
        :maxlength="maxlength"
        v-model.number="model"
        :name="name"
        :id="name"
        min="0"
        step="1"
        v-on:keypress="isNumber"
        :rules="rules"
        :disabled="disabled"
      />
    </div>
    <div v-else>
      <Field
        class="w-full px-2 py-1 text-lg border border-gray-200 disabled:opacity-50"
        :type="type"
        :maxlength="maxlength"
        v-model="model"
        :id="name"
        :name="name"
        :disabled="disabled"
        min="0"
        :rules="rules"
      />
    </div>
    <ErrorMessage class="mt-2 text-xs text-red-500" :name="name" />
  </div>
</template>

<script>
import { Field, ErrorMessage } from "vee-validate";
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "Input",
  components: { Field, ErrorMessage },
  props: {
    name: {
      required: true,
      type: String,
    },
    type: {
      required: false,
      default: () => "text",
      type: String,
    },
    label: {
      required: false,
      default: () => null,
      type: String,
    },
    disabled: {
      required: false,
      default: () => false,
      type: Boolean,
    },
    rules: {
      required: false,
      default: () => null,
      type: Function,
    },
    maxlength: {
      required: false,
      default: () => 999,
      type: Number,
    },
  },
  setup({ name, type }) {
    const store = useStore();

    function isNumber(e) {
      if ([44, 46].indexOf(e.keyCode) !== -1) {
        e.preventDefault();
      }

      return true;
    }

    const model = computed({
      get() {
        return store.getters.resolve(name);
      },
      set(value) {
        if (type === "number") {
          store.commit("set", { name, value: value ? Number(value) : null });
        } else {
          store.commit("set", { name, value: value !== "" ? value : null });
        }
      },
    });

    return {
      model,
      isNumber,
    };
  },
};
</script>
